import React from 'react';
import style from './style.scss';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';

class NeedOffersByCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.loadDemandByCategory = this.loadDemandByCategory.bind(this);
  }

  loadDemandByCategory() {
    this.props.history.push({
      pathname: '/demands',
      search: `?category=${this.props.id}`
    });
  }

  render() {
    return (
      <div className="need-offer-by-category">
        <div className='need-offer-by-category-img-wrap' onClick={this.loadDemandByCategory}>
          <i className={`favorite-image ${this.props.largeIcon}`}></i>
        </div>
        <p className='description-black'><Link className='description-link' to={`/demands?categoryId=${this.props.id}`}>{this.props.description}</Link></p>
        <p className='description-red'><Link className='description-link' to={`/demands?categoryId=${this.props.id}`}>{this.props.countApprovedDemands + ' nhu cầu'}</Link></p>
      </div>
    );
  }
}

NeedOffersByCategory.defaultProps = {
  link: '',
  image: '',
  description: '',
  count: ''
};

export default withRouter(NeedOffersByCategory);



// WEBPACK FOOTER //
// ./components/partials/need-offer-by-category/NeedOffersByCategory.jsx